/* NoticiaDetalle - Solo Lógica */
import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';
import NewsDetailsUI from '../ui/News_Details_UI';

const NoticiaDetalle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language, translations } = useContext(LanguageContext);
  const { noticia } = location.state || {};
  
  const [comentario, setComentario] = useState('');
  const [comentarios, setComentarios] = useState([]);

  // Validar si la noticia está presente
  if (!noticia) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-center text-gray-500 text-xl">
          {language === 'es' ? 'Noticia no encontrada' : 'News not found'}
        </p>
      </div>
    );
  }

  // Obtener traducciones del idioma seleccionado
  const texts = translations[language].noticias;

  // Handlers
  const handleVolverNoticias = () => {
    navigate('/noticias');
  };

  const handleComentarioChange = (e) => {
    setComentario(e.target.value);
  };

  const handleEnviarComentario = () => {
    if (comentario.trim()) {
      setComentarios([...comentarios, {
        id: Date.now(),
        texto: comentario,
        fecha: new Date().toLocaleDateString()
      }]);
      setComentario('');
    }
  };

  const handleCompartirFacebook = () => {
    const url = window.location.href;
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
  };

  const handleCompartirTwitter = () => {
    const url = window.location.href;
    const text = noticia.title[language];
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank');
  };

  const handleCompartirLinkedIn = () => {
    const url = window.location.href;
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
  };

  return (
    <NewsDetailsUI
      noticia={noticia}
      language={language}
      texts={texts}
      comentario={comentario}
      comentarios={comentarios}
      onVolverNoticias={handleVolverNoticias}
      onComentarioChange={handleComentarioChange}
      onEnviarComentario={handleEnviarComentario}
      onCompartirFacebook={handleCompartirFacebook}
      onCompartirTwitter={handleCompartirTwitter}
      onCompartirLinkedIn={handleCompartirLinkedIn}
    />
  );
};

export default NoticiaDetalle;